import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';
import RightModalLayout from '../layouts/Modal/RightModalLayout';
import { SIDEBAR_ACTIONS, TAGS_ACTIONS } from '../../constants/actionsConstants';
import InputComponent from '../components/InputMC';
import FormProviderMC from '../components/FormProviderMC';
import { createTag, updateTag } from '../../actions/tagsActions';

const CREATE_EDIT_VARIANT = {
  CREATE: 'CREATE',
  EDIT: 'EDIT'
};

const CreateEditTag = ({
  tagSelected,
  VARIANT = CREATE_EDIT_VARIANT.CREATE,
  refetch
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Tags');

  const { tag } = useSelector((state) => state.tagsReducer);
  const isCreateVariant = VARIANT === CREATE_EDIT_VARIANT.CREATE;
  const title = isCreateVariant ? t('sidebar_edit_create.title.create') : t('sidebar_edit_create.title.update');

  const schema = object().shape({
    name: string().required(t('sidebar_edit_create.name_field_required')),
    tagColor: string().required()
  });

  const defaultValues = {
    name: tagSelected?.name,
    tagColor: tagSelected?.tagColor || '#000000'
  };

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });

  const tagDTO = (tagToTransform) => ({
    id: tagToTransform.id,
    tag: tagToTransform.name,
    tag_color: tagToTransform.tagColor,
    font_color: tagToTransform.fontColor
  });

  const handleSubmit = (data) => {
    if (isCreateVariant) {
      dispatch(createTag({ tag: tagDTO(data) }, refetch));
    } else {
      dispatch(updateTag({ tag: tagDTO(data), id: tag.id }, refetch));
    }
  };

  useEffect(() => {
    if (isCreateVariant) {
      dispatch({ type: TAGS_ACTIONS.SET_DEFAULT_CREATE_TAG_INPUTS });
    } else {
      dispatch({ type: TAGS_ACTIONS.SET_DEFAULT_EDIT_TAG_INPUTS, payload: tagSelected });
    }
  }, []);

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={title}
        submitAction={methods.handleSubmit(handleSubmit)}
        cancelAction={() => dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR })}
        submitLabel={isCreateVariant ? t('sidebar_edit_create.save') : t('sidebar_edit_create.update')}
        cancelLabel={t('sidebar_edit_create.cancel')}
        buttonSubmitType="submit"
      >
        <FormProviderMC methods={methods} onSubmit={methods.handleSubmit(handleSubmit)}>
          <div className="tw-flex tw-flex-col tw-gap-4">
            <InputComponent
              rows={2}
              id="name"
              name="name"
              label={t('sidebar_edit_create.name_label')}
              className="tw-resize-none"
              useFloatingLabel
              secondaryLabel={t('sidebar_edit_create.name_placeholder')}
              maxLength={20}
            />
            <InputComponent
              id="tagColor"
              name="tagColor"
              label={t('sidebar_edit_create.color_label')}
              type="color"
            />
          </div>
        </FormProviderMC>
      </RightModalLayout>
    </div>
  );
};

export default CreateEditTag;
